import * as React from 'react';
import { UserNavItemProps } from '../../Navigator.type';
import { NavigatorService } from '../../Navigator.service';
import { NavigatorMap } from '../../Navigator.map';

export function UserNavItem({
  account,
  activeItem,
  pathName,
  onOpenSubmenu
}: UserNavItemProps) {
  const hasSubmenu = NavigatorService.shouldRenderUsersSubmenu(account);
  const isActive = activeItem === 'users';
  const usersIcon = NavigatorService.getFeatureIcon('users');
  const usersLabel = NavigatorService.getFeatureLabel('users');
  const schema = NavigatorMap.getFeatureSchema().users;

  if (account.accountType === 'personal') {
    return (
      <li className={`nav-item ${isActive ? 'ativo' : ''}`}>
        <a href={NavigatorService.getUsersUrl(account)}>
          <i className={`fa-light fa-${usersIcon}`}></i>
          <span>{usersLabel}</span>
        </a>
      </li>
    );
  }

  // Conta não-personal com submenu
  return (
    <li className={`nav-item ${isActive ? 'ativo' : ''} ${hasSubmenu ? 'submenu' : ''}`}>
      <a 
        href={hasSubmenu ? "#" : NavigatorService.getUsersUrl(account)}
        onClick={(event) => {
          if (hasSubmenu) {
            onOpenSubmenu(event, 'users');
          }
        }}
      >
        <i className={`fa-light fa-${usersIcon}`}></i>
        <span>{usersLabel}</span>
      </a>
      
      {hasSubmenu && schema?.items && (
        <ul className="submenu">
          {schema.items.map((item, index) => (
            <li 
              key={index} 
              className={NavigatorMap.isItemActive(pathName, account, item.url) ? 'ativo' : ''}
            >
              <a href={NavigatorMap.buildItemUrl(account, item.url)}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}
